import Vue from 'vue';
import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/vs.css';

import javascript from 'highlight.js/lib/languages/javascript';
hljs.registerLanguage('javascript', javascript);

import csharp from 'highlight.js/lib/languages/csharp';
hljs.registerLanguage('csharp', csharp);

import css from 'highlight.js/lib/languages/css';
hljs.registerLanguage('css', css);

import scss from 'highlight.js/lib/languages/scss';
hljs.registerLanguage('scss', scss);

import xml from 'highlight.js/lib/languages/xml';
hljs.registerLanguage('xml', xml);

Vue.directive('highlightjs', {
  inserted: function(el) {
    el.querySelectorAll('pre code:not(.hljs)').forEach(code => {
      hljs.highlightElement(code);
    });
  },
});
